import React, { Component } from 'react';
import DailyNewsService from '../../../services/daily-news';

import './future-posts-editor.css';

class FuturePostsEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      postsPerDay: 4
    };

    this.getFuturePosts(props);
  }

  getFuturePosts(props) {
    DailyNewsService.getFuturePosts()    
      .then((futurePosts) => {
        this.setState({ ...futurePosts });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  onChange = (postId, event) => {
  }

  getOnChange = (postId, field) => {
    return (event) => {
      const newValue = event.target.value;
      this.setState((prevState) => {
        return {
          posts: prevState.posts.map(post => {
            const additionals = {};

            if (post._id === postId) {
              if (field.startsWith('paragraph')) {
                const parIndex = +field.split('_')[1];
                additionals.paragraphs = [
                  ...post.paragraphs
                ];

                additionals.paragraphs[parIndex] = newValue;
              }
              else {
                additionals[field] = newValue;
              }
            }

            return {
              ...post,
              ...additionals
            };
          })
        }
      })
    }
  }

  getOnCheckboxClicked = (postId, field) => {
    return () => {
      this.setState((prevState) => {
        return {
          posts: prevState.posts.map(post => {
            const additionals = {};
            if (post._id === postId) {
              additionals[field] = post[field] === true ? false : true
            };

            return {
              ...post,
              ...additionals
            };
          })
        };
      })
    }
  }

  getImg = (imgUrl) => {
    if (!imgUrl) return '';
    return <img src={imgUrl} alt='post' height='200px'/>;
  }

  onPostsPerDayNumChange = (event) => {
    const num = +event.target.value;

    this.setState((prevState) => {
      return {
        postsPerDay: num
      };
    })
  }

  onSavePosts = () => {
    const numPostsPerDay = this.state.postsPerDay || 4;
    const posts = this.state.posts
      .filter(post => post.isToDelete !== true)
      .map(post => {
        return {
          ...post,
          paragraphs: post.paragraphs.filter(p => p)
        };
      });
    
    DailyNewsService.saveFuturePosts(posts, this.state.dormosheioPosts, numPostsPerDay)    
      .then(() => {
        window.location.href = 'https://dormoshe.io';
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  isPostTitleAndPublicationEqual = (post) => {
    return (post.title && post.title.toLowerCase()) === (post.publication && post.publication.toLowerCase());
  }

  render() {
    let body = 'Processing...';
    if (this.state && this.state.posts) {
      body = (
        <div>
          <section>
            {
              this.state.dormosheioPosts.map(({url, isNewsletterCandidate}, i) => 
                <div key={`news-candidate-${i}`} className={(isNewsletterCandidate && 'news-candidate')}><a href={url}>{url}</a></div>
              )
            }
          </section>
          
          <section>
            {
              this.state.posts.map((post, i) => 
                <div key={post._id} className={(post.isToDelete && 'hide') || (post.isNewsletterCandidate && 'news-candidate') || ''}>
                  <div><label>{i + 1} out of {this.state.posts.length}</label></div>
                                
                  <input 
                    type='checkbox' 
                    checked={post.isToDelete}
                    onChange={this.getOnCheckboxClicked(post._id, 'isToDelete')}/>
                  <label>To delete?</label>
                  
                  <input 
                    type='checkbox' 
                    checked={post.isNewsletterCandidate}
                    onChange={this.getOnCheckboxClicked(post._id, 'isNewsletterCandidate')}/>
                  <label>News Candidate?</label>

                  <h3>{post._id}</h3>
                                  
                  { !post.isToDelete && 
                    <div>
                      <input 
                        className={this.isPostTitleAndPublicationEqual(post) ? 'problem' : 'long-input'}
                        value={post.title} 
                        onChange={this.getOnChange(post._id, 'title')} /> 

                      <div className='post-paragraphs'>
                        <label>Paragraphs:</label>
                        <textarea 
                          required
                          className='long-input'
                          value={(post.paragraphs.length > 0 && post.paragraphs[0]) || ''} 
                          onChange={this.getOnChange(post._id, 'paragraph_0')}
                          rows='6' />
                        
                        <textarea 
                          className='long-input'
                          value={(post.paragraphs.length > 1 && post.paragraphs[1]) || ''} 
                          onChange={this.getOnChange(post._id, 'paragraph_1')}                    
                          rows='6' />
                        
                        { post.paragraphs.length > 2 && <textarea 
                          value={(post.paragraphs.length > 2 && post.paragraphs[2]) || ''} 
                          onChange={this.getOnChange(post._id, 'paragraph_2')}                    
                          rows='6' />
                        }
                      </div>

                      <div>
                        <label>Writer:</label>
                        <input 
                          value={post.writer || ''}
                          onChange={this.getOnChange(post._id, 'writer')} /> 
                      </div>

                      <div>
                        <label>Publication:</label>
                        <input 
                          value={post.publication || ''}
                          onChange={this.getOnChange(post._id, 'publication')} /> 
                      </div>

                      <div className={!post.sourceDate ? 'problem' : ''}>
                        <label>Source date:</label>
                        {post.sourceDate || ''}
                      </div>
                      
                      {/*<div>
                        <label>Publish date:</label>
                        {post.date}
                      </div>*/}
                      
                      <div>
                        <label>InternalUrlId:</label>
                        <input 
                          value={post.internalUrlId || ''}
                          onChange={this.getOnChange(post._id, 'internalUrlId')} /> 
                      </div>

                      <div>
                        <label>Url:</label>
                        <input 
                          value={post.url || ''}
                          onChange={this.getOnChange(post._id, 'url')} /> 

                        <a href={post.url} target='_blank'>Direct Link</a> 
                      </div>

                      <div>
                        <label>ImgUrl:</label>
                        <input 
                          value={post.imgUrl || ''}
                          onChange={this.getOnChange(post._id, 'imgUrl')} /> 
                      </div>

                      { this.getImg(post.imgUrl) }
                  </div> 
                  }                     
                <hr/>
              </div>
              )
            }
          </section>

          <input type='number' value={this.state.postsPerDay} onChange={this.onPostsPerDayNumChange} />
          <input type='button' value='Save' onClick={this.onSavePosts}/>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page future-posts-editor'>
        {body}
      </section>
    );
  }
}

export default FuturePostsEditor;
